import { useEffect, useRef } from "react";

export const EditableText = ({
  value,
  onChange,
  className = "",
  multiline = false,
}: {
  value: string | number;
  onChange: (v: string) => void;
  className?: string;
  multiline?: boolean;
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.innerText = String(value);
    }
  }, []);

  return (
    <div
      ref={ref}
      contentEditable
      suppressContentEditableWarning
      onInput={() => {
        if (!ref.current) return;
        onChange(ref.current.innerText);
      }}
      className={`cursor-text outline-none rounded px-1 hover:bg-gray-100 dark:hover:bg-gray-800 focus:bg-gray-100 dark:focus:bg-gray-800
        ${multiline ? "min-h-[60px] whitespace-pre-wrap" : ""}
        ${className}
      `}
    ></div>
  );
};
